import { AlertService } from 'src/app/providers/alert.service';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { ApiService } from "src/app/providers/api.service";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { LoaderServiceService } from "src/app/providers/loader-service.service";

@Component({
  selector: "sm-auto-invoicing-setting",
  templateUrl: "./auto-invoicing-setting.component.html",
  styleUrls: ["./auto-invoicing-setting.component.scss"],
})
export class AutoInvoicingSettingComponent implements OnInit, OnDestroy {
  apisub: Subscription;
  toShowCheckEmail: number = 0;
  toShowCheckWhatsapp: number = 0;
  toShowCheckInvoiceCreation: number = 0;
  toShowCheckDefaultVirtualMeeting: number = 0;
  toShowCheckOnlineMemberApply: number = 0;
  default_online_session_link: any;
  default_online_session_app: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private apiservice: ApiService,
    private ls: LoaderServiceService,
    private activemodal: MatDialogRef<AutoInvoicingSettingComponent>,
    private as:AlertService
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_MEMBER_AUTO_INVOICE_SENDING_SETTINGS
      ) {
        if (resdata.result) {
          this.default_online_session_link =
            resdata.result[0].default_online_session_link;
          this.default_online_session_app =
            resdata.result[0].default_online_session_app;

          this.toShowCheckEmail = resdata.result[0].email_status;
          this.toShowCheckWhatsapp = resdata.result[0].whtsapp_status;
          this.toShowCheckInvoiceCreation =
            resdata.result[0].invoice_creation_status;
          this.toShowCheckDefaultVirtualMeeting =
            resdata.result[0].default_online_session_link_status;
          this.toShowCheckOnlineMemberApply =
            resdata.result[0]?.allow_online_membership ?? 0;
        }

        this.ls.showLoader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SET_MEMBER_AUTO_INVOICE_SENDING_SETTINGS
      ) {
        if (resdata.result) {
          this.ls.showLoader = false;
          this.as.onOpenSnackbar("Membership settings saved successfully.",3000)
          this.activemodal.close({ msg: "success" });
        }
      }
    });
  }

  ngOnInit(): void {
    this.apiservice.getMemberAutoInvoiceSendingSettings(
      this.parentdata.entityHash,
    );
  }

  onToggleChange(event: any, type: any) {
    // whatsapp
    if (type == 1) {
      // -------- CHECK LOGIC-----------
      if (event.checked) {
        this.toShowCheckWhatsapp = 1;
      }
      // -------- UNCHECK LOGIC -------------
      else if (!event.checked) {
        this.toShowCheckWhatsapp = 0;
      }
    }
    // email
    else if (type == 2) {
      // -------- CHECK LOGIC-----------
      if (event.checked) {
        this.toShowCheckEmail = 1;
      }
      // -------- UNCHECK LOGIC -------------
      else if (!event.checked) {
        this.toShowCheckEmail = 0;
      }
    }
    // invoice creation
    else if (type == 3) {
      // -------- CHECK LOGIC-----------
      if (event.checked) {
        this.toShowCheckInvoiceCreation = 1;
      }
      // -------- UNCHECK LOGIC -------------
      else if (!event.checked) {
        this.toShowCheckInvoiceCreation = 0;
        this.toShowCheckEmail = 0;
        this.toShowCheckWhatsapp = 0;
      }
    } else if (type == 4) {
      // -------- CHECK LOGIC-----------
      if (event.checked) {
        this.toShowCheckOnlineMemberApply = 1;
      }
      // -------- UNCHECK LOGIC -------------
      else if (!event.checked) {
        this.toShowCheckOnlineMemberApply = 0;
      }
    }
    else if (type == 5) {
      // -------- CHECK LOGIC-----------
      if (event.checked) {
        this.toShowCheckDefaultVirtualMeeting = 1;
      }
      // -------- UNCHECK LOGIC -------------
      else if (!event.checked) {
        this.toShowCheckDefaultVirtualMeeting = 0;
      }
    }
  }
  
  onSave() {
    let obj = {
      entity_hash: this.parentdata.entityHash,
      whatsapp_status: this.toShowCheckWhatsapp,
      invoice_creation_status: this.toShowCheckInvoiceCreation,
      email_status: this.toShowCheckEmail,
      allow_online_membership: this.toShowCheckOnlineMemberApply,
      default_online_session_link_status: this.toShowCheckDefaultVirtualMeeting,
      default_online_session_app: this.default_online_session_app,
      default_online_session_link: this.default_online_session_link,

      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
    };

    console.log(obj);

    this.ls.showLoader = true;
    this.apiservice.setMemberAutoInvoiceSendingSettings(obj);
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }
}
